module.exports = __webpack_public_path__ + "static/media/web-dev-certificate-of-training.aa7d98f5.jpg";